import { IHttpErrorResponseModel, IPersonnelDdcModel, IPersonnelDdcSuiviModel } from "@common-models/*"
import { useQuery } from "react-query"
import { AxiosError } from "axios"
import { toast } from "react-toastify"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MyAlert from "@common-utils/MyAlert"
import React from "react"
import { getSuiviConnectedUserDdcRequest } from "../../../mes-activites/ddc/core/_requests"
import {
     CONST_PERSONNEL_DDC_SUIVI_TYPE_ACCEPTATION_DEMANDE,
     CONST_PERSONNEL_DDC_SUIVI_TYPE_ANNULATION_DEMANDE,
     CONST_PERSONNEL_DDC_SUIVI_TYPE_ENVOI_DEMANDE,
     CONST_PERSONNEL_DDC_SUIVI_TYPE_RECTIFICATION_AVANT_DECISION_RESPONSABLE,
     CONST_PERSONNEL_DDC_SUIVI_TYPE_REJET_DEMANDE,
} from "@common-constants/*"

const REACT_QUERY_KEY_GET_DE_SUIVI = "REACT_QUERY_KEY_GET_DE_SUIVI"
const PersonnelDdcSuivi = ({ ddc }: IPersonnelDdcSuiviPropsModel) => {
     // Query
     const suiviQuery = useQuery<IPersonnelDdcSuiviModel[], AxiosError>(REACT_QUERY_KEY_GET_DE_SUIVI, async () => {
          return getSuiviConnectedUserDdcRequest(ddc.id as number)
               .then(r => r.data)
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Toast error
                    toast.error(error?.detail, { autoClose: false })

                    throw e
               })
     })

     function faIconAccordingToTypeSuivi(type: any) {
          if (type === CONST_PERSONNEL_DDC_SUIVI_TYPE_ENVOI_DEMANDE) return "fa-paper-plane"
          if (type === CONST_PERSONNEL_DDC_SUIVI_TYPE_RECTIFICATION_AVANT_DECISION_RESPONSABLE) return "fa-edit"
          if (type === CONST_PERSONNEL_DDC_SUIVI_TYPE_ANNULATION_DEMANDE) return "fa-times-circle"
          if (type === CONST_PERSONNEL_DDC_SUIVI_TYPE_ACCEPTATION_DEMANDE) return "fa-thumbs-up"
          if (type === CONST_PERSONNEL_DDC_SUIVI_TYPE_REJET_DEMANDE) return "fa-thumbs-down"
          return ""
     }

     return (
          <>
               {/* Is fetching */}
               {suiviQuery.isFetching && (
                    <div className={"text-center p-5"}>
                         <MySimpleSpinner size={"xl"} />
                    </div>
               )}

               {/* Is error */}
               {!suiviQuery.isFetching && suiviQuery.isError && (
                    <MyAlert type={"danger"} classNames={"mb-4"}>
                         <div className={"d-flex align-items-center"}>
                              <span className={"me-2"}>{suiviQuery.error?.response?.data?.detail}</span>
                              <button className={"btn btn-sm btn-danger d-flex align-items-center p-0 px-3 py-2"} onClick={() => suiviQuery.refetch()}>
                                   Recharger
                              </button>
                         </div>
                    </MyAlert>
               )}

               {/* Without data */}
               {!suiviQuery.isFetching && !suiviQuery.isError && suiviQuery.data!.length === 0 && <MyAlert type={"primary"}>Aucun suivi à afficher</MyAlert>}

               {/* With data */}
               {!suiviQuery.isFetching && !suiviQuery.isError && suiviQuery.data!.length > 0 && (
                    <>
                         <div className="timeline">
                              {suiviQuery.data!.map((suivi, key) => (
                                   <div className="timeline-item" key={key}>
                                        <div className="timeline-line w-40px"></div>
                                        <div className="timeline-icon symbol symbol-circle symbol-40px">
                                             <div className={`symbol-label text-dark`}>
                                                  <span className={`fas ${faIconAccordingToTypeSuivi(suivi.type)} fs-4`}></span>
                                             </div>
                                        </div>
                                        <div className="timeline-content mb-10 mt-n1">
                                             <div className="pe-3 mb-5">
                                                  <div className="fs-5 fw-bold mb-2">{suivi.typeLabel}</div>
                                                  <div className="d-flex align-items-center mt-1 fs-6">
                                                       <div className="text-dark me-2 fs-7">
                                                            Le {suivi.createdAt?.format("dddd DD MMMM YYYY à H[h]mm")}{" "}
                                                            {suivi.personnel ? (
                                                                 <b className={"text-center"}>par {suivi.personnel.prenomNom}</b>
                                                            ) : (
                                                                 <b className={"text-dark"}>par {ddc.personnel?.prenomNom}</b>
                                                            )}
                                                       </div>
                                                  </div>
                                             </div>

                                             {suivi.commentaire && (
                                                  <div className="overflow-auto pb-5">
                                                       <p className={"m-0 mb-2 fw-bold"}>Commentaire</p>
                                                       <div className="d-flex align-items-center border border-dashed border-gray-300 rounded p-7">
                                                            <div>{suivi.commentaire}</div>
                                                       </div>
                                                  </div>
                                             )}
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </>
               )}
          </>
     )
}

interface IPersonnelDdcSuiviPropsModel {
     ddc: IPersonnelDdcModel
}

export default PersonnelDdcSuivi
